
import React, { useState } from 'react'
import { Modal, Button, Input, message } from 'antd';
import { numberParseChina, formatNum } from "@/utils/utils";
import "./orderPubPrint.css";

//打印

export interface IPrintClumns {
    title: string,
    dataIndex: string,
    render?: (text: string | number) => string
}

interface IPrintFieldInfo {
    fieldLabel: string,
    fieldValue?: string | number,
    suffix?: string,
    prefix?: string,
    className?: string,
    empty?: boolean
}
interface IHeader {
    fieldLabel: string,
    fieldValue?: string | number,
    className?: string,
    border?: boolean,
}
interface IPrintShow {
    header: IHeader[],
    footer: IPrintFieldInfo[],
    totalAmount: IPrintFieldInfo[],
    itemAmount?: IPrintFieldInfo[]
}

interface Item {
    [key: string]: string | number | any
}

export interface IPrintType {
    title?: string,
    type?: string,
    visible: boolean,
    onClose: () => void,
    onConfirm?: () => void,
    itemClumns?: IPrintClumns[], //维修项目字段及信息
    columns: IPrintClumns[],  //商品字段及信息
    dataSource: Item[],      //商品数据
    itemDataSource?: Item[],  //维修项目数据
    printShow: IPrintShow    //header 及 footer
}

export function YhPrint({
    title = "",
    type = "",
    visible,
    onClose,
    onConfirm = () => null,
    columns,
    itemClumns,
    itemDataSource,
    dataSource,
    printShow
}: IPrintType) {

    const [titles, setTieles] = useState<string>(title);
    //设置抬头
    const setTitle = () => {
        let title: string = "";
        Modal.confirm({
            title: '请输入设置的名称',
            content: <Input placeholder="请输入设置的名称" onChange={(e) => { title = e.target.value }} />,
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    if (title) {
                        resolve(title);
                    } else {
                        message.warning("请输入要设置的名称");
                        reject('请输入要设置的名称');
                    }
                }).then(res => {
                    setTieles(res as string);
                });
            },
            onCancel: () => { }
        })
    };

    //打印
    const print = () => {
        const el: HTMLElement | null = document.getElementById('public-print-container');
        const iframe: any = document.createElement('IFRAME');
        let doc = null;
        document.body.appendChild(iframe);
        doc = iframe.contentWindow.document;
        // 引入打印的专有CSS样式，根据实际修改
        doc.write(`<LINK rel="stylesheet" type="text/css" href="./orderPubPrint.css">`);
        doc.write(el?.innerHTML);
        doc.close();
        // 获取iframe的焦点，从iframe开始打印
        iframe.contentWindow.focus();
        iframe.onload = () => {
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
        };
        if (navigator.userAgent.indexOf("MSIE") > 0) {
            document.body.removeChild(iframe);
        }
        onConfirm()
    };

    //遍历商品td
    const mapGoods = (goods: Item) => {
        return columns.filter(item => item).map((item, index) => <td key={index}>{item.render ? item.render(goods[item.dataIndex]) : goods[item.dataIndex]}</td>)
    }
    //遍历项目td
    const itemGoods = (goods: Item) => {
        return itemClumns?.filter(item => item).map((item, index) => <td key={index}>{item.render ? item.render(goods[item.dataIndex]) : goods[item.dataIndex]}</td>)
    }

    return (
        <Modal
            title="打印详情"
            width={1300}
            visible={visible}
            onCancel={onClose}
            footer={[
                <Button type="link" onClick={onClose} key="back"> 取消</Button>,
                <Button type="link" onClick={print} key="submit">确认打印</Button>,
                <Button type="link" onClick={setTitle} key="setPrintName">设置</Button>
            ]}
        >
            <div id="public-print-container" >
                <div className="print-container">
                    <div className="header">
                        {printShow.header && printShow.header.map((item, index) => (
                            <ul>
                                <li className={item.border ? "li-borderColor" : ""}>{item.fieldLabel}</li>
                                <li className={item.border ? "li-borderColor" : ""}>{item.fieldValue}</li>
                            </ul>))}
                    </div>
                    <table className="mingxi">
                        <tbody>
                            <tr className="print-center" >
                                {itemClumns && itemDataSource && itemDataSource.length > 0 && itemClumns.filter(item => item).map((item, index) =>
                                    <td key={index}>{item.title}</td>
                                )}
                            </tr>
                            {itemDataSource && itemDataSource.length > 0 &&
                                itemDataSource.map((item, index) =>
                                    <tr key={index} className="print-center">
                                        {itemGoods(item)}
                                    </tr>
                                )}
                            {printShow.itemAmount && itemDataSource && itemDataSource?.length > 0 &&
                                printShow.itemAmount.map((item, index) =>
                                    <tr key={index} style={{ height: "30px" }}>
                                        <td colSpan={columns.filter(item => item).length - 1}>
                                            {item.fieldLabel + "："}
                                            {/* <span className="amount-span">{`(${dataSource.length}项)`}</span> */}
                                            {/* <span className="ml-10">{`人民币（大写）${numberParseChina(item.fieldValue ?? 0)}`}</span> */}
                                        </td>
                                        <td colSpan={1}>{item.empty ? "" : `${item.prefix ?? ""}${formatNum(item.fieldValue)}${item.suffix ?? ""}`}</td>
                                    </tr>
                                )}
                            <tr className="print-center" >
                                {columns && columns.filter(item => item).map((item, index) =>
                                    <td key={index}>{item.title}</td>
                                )}
                            </tr>
                            {dataSource && dataSource.length > 0 &&
                                dataSource.map((item, index) =>
                                    <tr key={index} className="print-center">
                                        {mapGoods(item)}
                                    </tr>
                                )}

                            {printShow.totalAmount &&
                                printShow.totalAmount.map((item, index) =>
                                    <tr key={index} style={{ height: "30px" }}>
                                        <td colSpan={columns.filter(item => item).length - 1}>
                                            {item.fieldLabel ? item.fieldLabel + "：" : ""}
                                            {/* <span className="amount-span">{dataSource.length?`(${dataSource.length}项)`:""}</span> */}
                                            {/* <span className="ml-10">{`人民币（大写）${numberParseChina(item.fieldValue ?? 0)}`}</span> */}
                                        </td>
                                        <td colSpan={1}>{item.empty ? "" : `${item.prefix ?? ""}${formatNum(item.fieldValue)}${item.suffix ?? ""}`}</td>

                                    </tr>
                                )}
                        </tbody>
                    </table>
                    <ul className="footer">
                        {printShow.footer && printShow.footer.map((item, index) => <li className={item.className ?? ""} key={index}>{item.fieldLabel + '：' + item.fieldValue}</li>)}
                    </ul>
                </div>
            </div>
            <></>
            {/* <div id="public-print-container">
                {visible && <div className="print-container">
                    <h2 className="title">{`${titles}${type}`}</h2>
                    <ul className="header">
                        {printShow.header && printShow.header.map((item, index) => <li key={index}>{item.fieldLabel + '：' + item.fieldValue}</li>)}
                    </ul>
                    <table className="mingxi">
                        <tbody>
                            <tr className="print-center" >
                                {columns && columns.filter(item => item).map((item, index) =>
                                    <td key={index}>{item.title}</td>
                                )}
                            </tr>

                            {dataSource && dataSource.length > 0 &&
                                dataSource.map((item, index) =>
                                    <tr key={index} className="print-center">
                                        {mapGoods(item)}
                                    </tr>
                                )}

                            {printShow.totalAmount &&
                                printShow.totalAmount.map((item, index) =>
                                    <tr key={index}>
                                        <td colSpan={columns.filter(item => item).length - 2}>
                                            {item.fieldLabel + "："}
                                            <span>{`(${dataSource.length}项)`}</span>
                                            <span className="ml-10">{`人民币（大写）${numberParseChina(item.fieldValue ?? 0)}`}</span>
                                        </td>
                                        <td colSpan={2}>{`￥${formatNum(item.fieldValue)}`}</td>
                                    </tr>
                                )}
                        </tbody>
                    </table>
                    <ul className="footer">
                        {printShow.footer && printShow.footer.map((item, index) => <li className={item.className ?? ""} key={index}>{item.fieldLabel + '：' + item.fieldValue}</li>)}
                    </ul>
                </div>}
            </div> */}
        </Modal>
    )
};
